import React from "react";

export const Image = ({ title, smallImage, onOpen }) => (
  <div className="portfolio-item">
    <div className="hover-bg">
      <button type="button" className="hover-trigger" onClick={onOpen}>
        <div className="hover-text">
          <h4>{title}</h4>
        </div>
        <img src={smallImage} className="img-responsive" alt={title} />
      </button>
    </div>
  </div>
);
